import { POSTS_PER_PAGE } from '../constants/pagination';
import { startLoadingCategory } from './start-loading-category';
import { stopLoadingCategory } from './stop-loading-category';
import fetchPosts from './fetch-posts';
import { actionPromiseCache } from '../services/action-promise-cache';
import { isSSR } from '../../common/store/basic-params/basic-params-selectors';
import { markPostsAsSeen } from '../containers/user-activity';

const finishLoading = (dispatch, categoryId) => {
  dispatch(stopLoadingCategory(categoryId));
};

export const fetchCategoryPosts = actionPromiseCache(
  ({ siteMemberId, categoryId, page, sort, postType, pageSize = POSTS_PER_PAGE }) =>
    (dispatch, getState) => {
      const state = getState();

      dispatch(startLoadingCategory(categoryId));
      const promise = dispatch(
        fetchPosts({ siteMemberId, categoryId, page, pageSize, sort, postType }),
      );

      if (!isSSR(state)) {
        promise.then((response) => {
          if (response.body.length > 0) {
            dispatch(markPostsAsSeen(response.body.map((p) => p._id)));
          }
        });
      }

      return promise
        .then(() => finishLoading(dispatch, categoryId))
        .catch(() => finishLoading(dispatch, categoryId))
        .then(() => promise);
    },
  {
    cacheKeyBuilder: (args) => `${args.categoryId}${args.page}${args.sort}${args.siteMemberId}`,
    cacheTime: 1000,
    ignoreResolve: true,
  },
);
